export class ContractType {
    code: number = 0;
    name: string;

    loadOwnerFromServer(r?: any) {
        if (r.code)
            this.code = r.code;

        if (r.name)
            this.name = r.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ContractType.model.ts